import { createApi } from '@reduxjs/toolkit/query/react'
import {baseQuery} from '../baseQuery';

const refetchSeconds = process.env.REACT_APP_REFETCH_SECONDS ? parseInt(process.env.REACT_APP_REFETCH_SECONDS) : 30;

export const listedAnimeApi = createApi({
    reducerPath: 'listedAnimeApi',
    baseQuery,
    tagTypes: ['ListedAnime', 'AnimeList'],
    keepUnusedDataFor: 300,
    refetchOnMountOrArgChange: refetchSeconds,
    endpoints: (builder) => ({
        getListedAnimeOfList: builder.query({
            query: ({
                slug,
                status,
                searchQuery = ''
            }) => {
                let url = `anime-lists/${slug}/listed-anime-items/${status}`

                if (searchQuery.length > 3) {
                    url += `?query=${searchQuery}`
                }

                return {url}
            },
            providesTags: (result, _error, { slug }) => result ? [
                { type: 'ListedAnime', id: slug },
                ...result.listedAnime.map((item: any) => ({ type: 'ListedAnime', id: item.slug }))
            ] : [{ type: 'AnimeList', id: slug }]
        }),
        relocateListedAnime: builder.mutation({
            query: ({listSlug, listedAnimeSlug,  newListSlug, newStatus, type}) => ({
                url: `anime-lists/${listSlug}/listed-anime-items/${listedAnimeSlug}/relocate`,
                method: 'POST',
                body: {
                    slugOfTargetList: newListSlug,
                    newStatus: newStatus,
                    relocationType: type
                },
            }),
            invalidatesTags: (_result, _error, { listSlug, newListSlug, listedAnimeSlug }) => [
                { type: 'AnimeList', id: listSlug },
                { type: 'AnimeList', id: newListSlug },
                { type: 'ListedAnime', id: listedAnimeSlug }
            ]
        }),
        deleteListedAnime: builder.mutation({
            query: ({listSlug, listedAnimeSlug}) => ({
                url: `anime-lists/${listSlug}/listed-anime-items/${listedAnimeSlug}`,
                method: 'DELETE'
            }),
            invalidatesTags: (_result, _error, { listSlug, listedAnimeSlug }) => [
                { type: 'AnimeList', id: listSlug },
                { type: 'ListedAnime', id: listedAnimeSlug }
            ]
        }),
        updateListedAnime: builder.mutation({
            query: ({listSlug, listedAnimeSlug, ...body}) => ({
                url: `anime-lists/${listSlug}/listed-anime-items/${listedAnimeSlug}`,
                method: 'PUT',
                body
            }),
            invalidatesTags: (_result, _error, { listSlug, listedAnimeSlug }) => [
                { type: 'AnimeList', id: listSlug },
                { type: 'ListedAnime', id: listedAnimeSlug }
            ]
        }),
        addEpisode: builder.mutation({
            query: ({listSlug, listedAnimeSlug, episodes}) => ({
                url: `anime-lists/${listSlug}/listed-anime-items/${listedAnimeSlug}/episode/add`,
                method: 'POST',
                body: {episodes}
            }),
            invalidatesTags: (_result, _error, { listSlug, listedAnimeSlug }) => [
                { type: 'AnimeList', id: listSlug },
                { type: 'ListedAnime', id: listedAnimeSlug }
            ]
        }),
        searchListedAnime: builder.query({
            query: (body) => ({
                url: `listed-anime-items/search`,
                method: 'POST',
                body,
            }),
            providesTags: ['ListedAnime']
        }),
    }),
})

export const {
    useLazyGetListedAnimeOfListQuery,
    useRelocateListedAnimeMutation,
    useDeleteListedAnimeMutation,
    useUpdateListedAnimeMutation,
    useAddEpisodeMutation,
    useLazySearchListedAnimeQuery
} = listedAnimeApi
